import React, { Component } from "react";
import { withAuthorization } from "../Session";
import * as ROUTES from "../../constants/routes";
import { Card, Container, Row, Col } from "reactstrap";

import "./userDetails.css";
import { Button, Form, FormGroup, Label, Input } from "reactstrap";
import uuid from "uuid";
class UserDetails extends Component {
  state = {
    customer: null
  };
  constructor(props) {
    super(props);

    console.log(
      "constructor:UaerDetails customer --> ",
      this.props.location.state.selectedCustomer
    );
    this.state = { customer: this.props.location.state.selectedCustomer };
    console.log(
      "This is the constructor of User Details--> ",
      "Comapany name is: ",
      this.state.customer.CompanyName,
      ", Comapany id is: ",
      this.props.location.state.selectedCustomer.uid,
      ", modal: ",
      this.props.location.state.modal
    );
    console.log("uuidv4():", uuid("v3"));
  }
  onChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };
  goBack = event => {
    this.props.history.push(ROUTES.LIST_USERS);
  };
  render() {
    const {
      CompanyName,
      ownerName,
      lastname,
      active,
      gstin,
      mobile,
      emailId,
      facebookId,
      twitterId,
      creditDays,
      building,
      addressline1,
      addressline2,
      landmark,
      city,
      company_state,
      pincode,
      address_type
    } = this.state.customer;
    console.log("render():companyName", CompanyName, " Is it active:", active);
    return (
      <Container>
        <Row>
          <Col xs="12">
            <Card body className="form_submit_card">
              <h3 className="text-center text-warning">Dealer Onboarding</h3>
              <Form onSubmit={this.goBack}>
                <Row className="formsubmit_field_align">
                  <Col md="12" className="form_row_algn">
                    <div className="d-inline-flex heading_line_belw">
                      <h6 className="row_heading">Company Info</h6>
                    </div>
                    <div className="form_algn">
                      <FormGroup className="d-inline-flex">
                        <Label className="label_fnt_size text-muted">
                          Company
                        </Label>
                        <Input
                          type="text"
                          name="CompanyName"
                          id=""
                          placeholder=" *"
                          pattern="[a-zA-Z0-9\s]{3,}"
                          required
                          autoComplete="off"
                          title="Registered Co. name"
                          value={CompanyName}
                          onChange={this.onChange}
                        />
                      </FormGroup>
                      <FormGroup className="d-inline-flex">
                        <Label className="label_fnt_size text-muted">
                          Owner Name
                        </Label>
                        <Input
                          type="text"
                          name="ownerName"
                          id=""
                          placeholder=" *"
                          pattern="[a-zA-Z]{3,}"
                          autoComplete="off"
                          value={ownerName}
                          required
                          onChange={this.onChange}
                        />
                      </FormGroup>
                      <FormGroup className="d-inline-flex">
                        <Label className="label_fnt_size text-muted">
                          Last Name
                        </Label>
                        <Input
                          type="text"
                          name="lastname"
                          id=""
                          placeholder=" *"
                          pattern="[a-zA-Z]{1,}"
                          autoComplete="off"
                          value={lastname}
                          required
                          onChange={this.onChange}
                        />
                      </FormGroup>
                    </div>
                  </Col>
                  <Col md="12" className="form_row_algn">
                    <div>
                      <FormGroup className="d-inline-flex">
                        <Label className="label_fnt_size text-muted">
                          GSTIN
                        </Label>
                        <Input
                          type="text"
                          name="gstin"
                          id=""
                          placeholder=" *"
                          pattern="^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$"
                          required
                          title="Valid GSTIN as per Govt. of India standard"
                          value={gstin}
                          onChange={this.onChange}
                        />
                      </FormGroup>
                      <FormGroup className="d-inline-flex">
                        <Label className="label_fnt_size text-muted">
                          Mobile Number
                        </Label>
                        <Input
                          type="text"
                          name="mobile"
                          id=""
                          placeholder=" * 10 Digits"
                          pattern="[6789][0-9]{9}"
                          required
                          title="10 digits, without +91"
                          value={mobile}
                          onChange={this.onChange}
                        />
                      </FormGroup>
                      <FormGroup className="d-inline-flex">
                        <Label className="label_fnt_size text-muted">
                          Credit Days *
                        </Label>
                        <Input
                          type="text"
                          name="creditDays"
                          id=""
                          placeholder=" Max 100 days"
                          pattern="^[1-9][0-9]?$|^100$"
                          autoComplete="off"
                          title="Allowed max of 100 days"
                          value={creditDays}
                          required
                          onChange={this.onChange}
                        />
                      </FormGroup>
                    </div>
                  </Col>
                  <Col md="12" className="form_row_algn">
                    <div className="d-inline-flex heading_line_belw">
                      <h6 className="row_heading">Social</h6>
                    </div>

                    <div className="form_algn">
                      <FormGroup className="d-inline-flex">
                        <Label className="label_fnt_size text-muted">
                          Email Id
                        </Label>
                        <Input
                          type="email"
                          name="email"
                          id=""
                          placeholder=" *"
                          autoComplete="off"
                          required
                          title="Enter the Company Email id"
                          value={emailId}
                          onChange={this.onChange}
                        />
                      </FormGroup>
                      <FormGroup className="d-inline-flex">
                        <Label className="label_fnt_size text-muted">
                          Facebook
                        </Label>
                        <Input
                          type="text"
                          name="facebookId"
                          id=""
                          placeholder=" Facebook Id"
                          autoComplete="off"
                          value={facebookId}
                          onChange={this.onChange}
                        />
                      </FormGroup>
                      <FormGroup className="d-inline-flex">
                        <Label className="label_fnt_size text-muted">
                          Twitter
                        </Label>
                        <Input
                          type="text"
                          name="twitterId"
                          id=""
                          placeholder=" Twitter handle"
                          autoComplete="off"
                          value={twitterId}
                          onChange={this.onChange}
                        />
                      </FormGroup>
                    </div>
                  </Col>
                  <Col md="12" className="form_algn">
                    <div className="d-inline-flex heading_line_belw">
                      <h6 className="row_heading">Address </h6>
                    </div>
                  </Col>
                  <Col md="12" className="form_algn">
                    <FormGroup className="d-inline-flex">
                      <Label className="label_fnt_size text-muted">
                        Building/Office
                      </Label>
                      <Input
                        type="text"
                        name="building"
                        id=""
                        placeholder=" *"
                        required
                        value={building}
                        onChange={this.onChange}
                      />
                    </FormGroup>
                    <FormGroup className="d-inline-flex">
                      <Label className="label_fnt_size text-muted">
                        Street
                      </Label>
                      <Input
                        type="text"
                        name="addressline1"
                        id=""
                        placeholder=" *"
                        required
                        value={addressline1}
                        onChange={this.onChange}
                      />
                    </FormGroup>
                    <FormGroup className="d-inline-flex">
                      <Label className="label_fnt_size text-muted">
                        Locality
                      </Label>
                      <Input
                        type="text"
                        name="addressline2"
                        id=""
                        placeholder=" *"
                        required
                        value={addressline2}
                        onChange={this.onChange}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="12" className="form_algn">
                    <FormGroup className="d-inline-flex">
                      <Label className="label_fnt_size text-muted">
                        Landmark
                      </Label>
                      <Input
                        type="text"
                        name="landmark"
                        id=""
                        placeholder="Near . . ."
                        value={landmark}
                        onChange={this.onChange}
                      />
                    </FormGroup>
                    <FormGroup className="d-inline-flex">
                      <Label className="label_fnt_size text-muted">
                        City/Town
                      </Label>
                      <Input
                        type="text"
                        name="city"
                        id=""
                        placeholder=" *"
                        required
                        value={city}
                        onChange={this.onChange}
                      />
                    </FormGroup>
                    <FormGroup className="d-inline-flex">
                      <Label className="label_fnt_size text-muted">
                        State *
                      </Label>
                      <Input
                        type="select"
                        id=""
                        name="company_state"
                        defaultValue="karnataka"
                        onChange={this.onChange}
                      >
                        <option value="">Choose State</option>
                        <option value="karnataka">Karnataka</option>
                        <option value="puducherry">Puducherry</option>
                        <option value="tamilnadu">Tamilnadu</option>
                        <option value="andhrapradesh">Andhra Pradesh</option>
                        <option value="telengana">Telengana</option>
                        <option value="kerala">Kerala</option>
                      </Input>
                    </FormGroup>
                  </Col>
                  <Col md="12" className="form_algn">
                    <FormGroup className="d-inline-flex">
                      <Label className="label_fnt_size text-muted">
                        Pin Code
                      </Label>
                      <Input
                        type="text"
                        name="pincode"
                        id=""
                        placeholder="6 Digits"
                        pattern="[0-9]{6}"
                        value={pincode}
                        onChange={this.onChange}
                      />
                    </FormGroup>
                    <FormGroup className="d-inline-flex">
                      <Label className="label_fnt_size text-muted">
                        Address is *
                      </Label>
                      <Input
                        type="select"
                        id=""
                        name="address_type"
                        defaultValue="office"
                        onChange={this.onChange}
                      >
                        <option value="">What type of address?</option>
                        <option value="office">Office</option>
                        <option value="warehouse">Warehouse</option>
                        <option value="other">Other</option>
                      </Input>
                    </FormGroup>
                  </Col>
                  <Col md="3" className="submit_btn">
                    <Button
                      color="primary"
                      size="sm"
                      className="width_max btn "
                      type="submit"
                    >
                      Back
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }
}

// export default UserDetails;
// const UserDetails = ({ match, history }) => {
//   console.log("UserDetails", match.params);
//   return (
//     <div>
//       <h1>User Details Page</h1>
//     </div>
//   );
// };

//export default UserDetails;
const condition = authUser => !!authUser;

export default withAuthorization(condition)(UserDetails);
